/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown>, codec: NonNullable<unknown> }} Audio_Embed_Export_Stream_SubtitleInputs */

const en_audio_embed_export_stream_subtitle = /** @type {(inputs: Audio_Embed_Export_Stream_SubtitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Subtitle ${i?.index}: ${i?.codec}`)
};

const fr_audio_embed_export_stream_subtitle = /** @type {(inputs: Audio_Embed_Export_Stream_SubtitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sous-titre ${i?.index}: ${i?.codec}`)
};

const de_audio_embed_export_stream_subtitle = /** @type {(inputs: Audio_Embed_Export_Stream_SubtitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Untertitel ${i?.index}: ${i?.codec}`)
};

const it_audio_embed_export_stream_subtitle = /** @type {(inputs: Audio_Embed_Export_Stream_SubtitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sottotitolo ${i?.index}: ${i?.codec}`)
};

const ru_audio_embed_export_stream_subtitle = /** @type {(inputs: Audio_Embed_Export_Stream_SubtitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Субтитры ${i?.index}: ${i?.codec}`)
};

const es_audio_embed_export_stream_subtitle = /** @type {(inputs: Audio_Embed_Export_Stream_SubtitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Subtítulo ${i?.index}: ${i?.codec}`)
};

const zh_cn2_audio_embed_export_stream_subtitle = /** @type {(inputs: Audio_Embed_Export_Stream_SubtitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`字幕 ${i?.index}: ${i?.codec}`)
};

const ja_audio_embed_export_stream_subtitle = /** @type {(inputs: Audio_Embed_Export_Stream_SubtitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`字幕 ${i?.index}: ${i?.codec}`)
};

const hi_audio_embed_export_stream_subtitle = /** @type {(inputs: Audio_Embed_Export_Stream_SubtitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`उपशीर्षक ${i?.index}: ${i?.codec}`)
};

const pt_pt2_audio_embed_export_stream_subtitle = /** @type {(inputs: Audio_Embed_Export_Stream_SubtitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Legenda ${i?.index}: ${i?.codec}`)
};

/**
* | output |
* | --- |
* | "Subtitle {index}: {codec}" |
*
* @param {Audio_Embed_Export_Stream_SubtitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_stream_subtitle = /** @type {((inputs: Audio_Embed_Export_Stream_SubtitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Stream_SubtitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_stream_subtitle(inputs)
	if (locale === "de") return de_audio_embed_export_stream_subtitle(inputs)
	if (locale === "it") return it_audio_embed_export_stream_subtitle(inputs)
	if (locale === "ru") return ru_audio_embed_export_stream_subtitle(inputs)
	if (locale === "es") return es_audio_embed_export_stream_subtitle(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_stream_subtitle(inputs)
	if (locale === "ja") return ja_audio_embed_export_stream_subtitle(inputs)
	if (locale === "hi") return hi_audio_embed_export_stream_subtitle(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_stream_subtitle(inputs)
	return en_audio_embed_export_stream_subtitle(inputs)
});